/**
 * 登录凭据：仅走浏览器/系统密码库（Credential Management API）。
 * 不把密码写入 localStorage / sessionStorage / 业务服务器。
 */

function credentialsApiAvailable() {
  try {
    return (
      typeof window !== 'undefined' &&
      window.isSecureContext &&
      !!navigator.credentials &&
      typeof navigator.credentials.get === 'function'
    )
  } catch (_) {
    return false
  }
}

function passwordCredentialSupported() {
  try {
    return credentialsApiAvailable() && typeof window.PasswordCredential === 'function'
  } catch (_) {
    return false
  }
}

/**
 * 从系统密码库尝试读取（Android Chrome / PWA 常见）。
 * 用户可取消；失败时静默返回 null。
 * @returns {Promise<{ username: string, password: string } | null>}
 */
export async function tryLoadPasswordFromSystemVault() {
  if (!credentialsApiAvailable()) return null
  try {
    const cred = await navigator.credentials.get({
      password: true,
      mediation: 'optional'
    })
    if (!cred || cred.type !== 'password') return null
    const username = (cred.id || cred.name || '').toString().trim()
    const password = cred.password != null ? String(cred.password) : ''
    if (!username || !password) return null
    return { username, password }
  } catch (_) {
    return null
  }
}

/**
 * 登录成功后请求系统保存密码（弹系统 UI，用户可拒绝）。
 * @returns {Promise<'stored' | 'unsupported' | 'skipped' | 'failed'>}
 */
export async function tryStorePasswordInSystemVault(username, password) {
  const u = (username || '').toString().trim()
  const p = password != null ? String(password) : ''
  if (!u || !p) return 'skipped'
  if (!passwordCredentialSupported()) return 'unsupported'
  try {
    const cred = new window.PasswordCredential({
      id: u,
      name: u,
      password: p
    })
    await navigator.credentials.store(cred)
    return 'stored'
  } catch (_) {
    return 'failed'
  }
}
